import { render, staticRenderFns } from "./lesson_block.vue?vue&type=template&id=9dca5a66&"
import script from "./lesson_block.vue?vue&type=script&lang=js&"
export * from "./lesson_block.vue?vue&type=script&lang=js&"
import style0 from "./lesson_block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports